var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPasswordEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45012 16.92C4.34849 15.8766 3.47954 14.6123 2.90012 13.21C2.80108 12.9793 2.75 12.731 2.75 12.48C2.75 12.229 2.80108 11.9806 2.90012 11.75C3.66983 9.87607 4.96088 8.26226 6.62012 7.09998C8.19462 5.99969 10.0799 5.43202 12.0001 5.47998C13.3817 5.44566 14.7519 5.73684 16.0001 6.32998M18.5601 8.04998C19.6554 9.09282 20.5206 10.3531 21.1001 11.75C21.1992 11.9806 21.2502 12.229 21.2502 12.48C21.2502 12.731 21.1992 12.9793 21.1001 13.21C20.3304 15.0839 19.0394 16.6977 17.3801 17.86C15.8056 18.9603 13.9204 19.5279 12.0001 19.48C10.6186 19.5143 9.24833 19.2231 8.00012 18.63",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71 13.65C8.56932 13.276 8.49816 12.8795 8.5 12.48C8.5 11.5517 8.86875 10.6615 9.52513 10.0051C10.1815 9.34875 11.0717 8.98 12 8.98C12.4 8.978 12.796 9.05 13.17 9.19M15.29 11.31C15.43 11.684 15.502 12.08 15.5 12.48C15.5 13.4083 15.1313 14.2985 14.4749 14.9549C13.8185 15.6113 12.9283 15.98 12 15.98C11.6005 15.9818 11.204 15.9107 10.83 15.77M3 20L19 4",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordEyeSlash);
export default __webpack_public_path__ + "static/media/icon_password_eye_slash.155c02d2e26acdcdfacfaa1b655b796d.svg";
export { ForwardRef as ReactComponent };